import { loadStripe } from '@stripe/stripe-js';

import conf from '@src/conf';

/**
 * Provider gating + Stripe.js loader for the Billing page (M34). The billing
 * payload carries a `provider` field ("stripe" | "simulated"); the Elements
 * checkout flow only mounts when provider is "stripe" AND a publishable key is
 * configured. Kept as a plain module (no JSX) so it is unit-testable in the
 * project's node-env Vitest.
 */

let stripePromise;
let loadedKey;

/** Memoized Stripe.js loader — one `js.stripe.com` script injection per key.
 * Prefers the key the billing payload serves at runtime and falls back to the
 * build-time bundle value, so a deployment can rotate the publishable key with
 * an env change + restart instead of an image rebuild. Returns null when no key
 * is configured either way (simulated mode or a misconfigured Stripe env), so
 * callers can show an inline error instead of mounting a blank Elements form. */
export function getStripePromise(publishableKey) {
  const key = publishableKey || conf.stripePublishableKey;
  if (!key) {
    return null;
  }
  if (!stripePromise || loadedKey !== key) {
    loadedKey = key;
    stripePromise = loadStripe(key);
  }
  return stripePromise;
}

/** True when the billing payload says Stripe is the live checkout provider. */
export function isStripeProvider(billing) {
  return billing?.provider === 'stripe';
}
